function subscribeForm(email){
  var settings = {
    "url": "https://a.klaviyo.com/client/subscriptions/?company_id=TwB9qJ&onsite=true",
    "method": "POST",
    "timeout": 0,
    "headers": {
      "REVISION": "2025-04-15",
      "Content-Type": "application/json"
    },
    "data": JSON.stringify({
      "data": {
        "type": "subscription",
        "attributes": {
          "profile": {
            "data": {
              "type": "profile",
              "attributes": {
                "email": email,
                "subscriptions": {
                  "email": {
                    "marketing": {
                      "consent": "SUBSCRIBED"
                    }
                  }
                }
              }
            }
          },
          "custom_source": "Subscription Box"
        },
        "relationships": {
          "list": {
            "data": {
              "type": "list",
              "id": "UrQTCX"
            }
          },
          "form": {
            "data": {
              "type": "form",
              "id": "T9jN7g"
            }
          },
          "form-version": {
            "data": {
              "type": "form-version",
              "id": 19407343
            }
          }
        }
      }
    }),
  };
  
  $.ajax(settings).done(function (response) {
    console.log(response);
  });
}
$(document).ready(function () {
  // Function to change steps
  function changeStep(hideStep, showStep) {
    $(hideStep).hide();
    $(showStep).show();
    $("html, body").animate({ scrollTop: 0 }, 800);
  }

  if ($(".main-steps-div").hasClass("new-hidding")) {
    $("#last-number").hide();
    $(".scnd-last-num").addClass("hide-img");
    $(".steps-col").addClass("steps-col-new");
  }

  var horseName = "";
  if (
    window.location.href.includes("form_type=customer#newsletter-form") ||
    window.location.href.includes("form_type=customer")
  ) {
    window.location.href = "/cart";
  }

  // Step 1 to Step 2 (formerly Step 3)
  $("#mak_one-btn").on("click", function () {
    horseName = $('input[name="properties[Horses Name]"]').val().trim();
    if (horseName === "") {
      alert("Please enter a horse name.");
      return;
    }
    if ($("#step-2").hasClass("new-hidding")) {
      changeStep("#step-1", "#step-3");
      $("#step-2").hide();
      $(".number-2").addClass("active");
      $(".number-1").removeClass("active");
      $("#replace-text1").text("What Colour Is " + horseName + "?");
    } else {
      changeStep("#step-1", "#step-2");
      $(".number-2").addClass("active");
      $(".number-1").removeClass("active");
      $("#replace-text").text("How big is " + horseName + "?");
    }
  });

  // Step 2 (formerly Step 3) to Step 1
  $("#step-2-back").on("click", function () {
    if ($("#step-2").hasClass("new-hidding")) {
      changeStep("#step-5", "#step-4");
      $(".mak_top-steps").show();
      $(".mak_steps-heading").hide();
      $(".number-3").addClass("active");
      $(".number-4").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
    } else if ($("#step-3").hasClass("new-hidding")) {
      changeStep("#step-5", "#step-4");
      $(".mak_top-steps").show();
      $(".mak_steps-heading").hide();
      $(".number-3").addClass("active");
      $(".number-2").removeClass("active");
      $(".number-4").removeClass("active");
      $(".number-1").removeClass("active");
    } else if ($("#step-4").hasClass("new-hidding")) {
      changeStep("#step-5", "#step-3");
      $(".mak_top-steps").show();
      $(".mak_steps-heading").show();
      $(".number-3").addClass("active");
      $(".number-2").removeClass("active");
      $(".number-4").removeClass("active");
      $(".number-1").removeClass("active");
    } else {
      changeStep("#step-5", "#step-4");
      $(".mak_top-steps").show();
      $(".mak_steps-heading").hide();
      $(".number-4").addClass("active");
    }
  });

  // Step 2 (formerly Step 3) to Step 3 (formerly Step 4)
  $("#mak_3-btn").on("click", function () {
    if ($("#step-3").hasClass("new-hidding")) {
      changeStep("#step-2", "#step-4");
      $(".number-3").addClass("active");
      $(".number-4").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $("#replace-text1").text("What Colour Is " + horseName + "?");
      $("#step-3").hide();
      $(".mak_steps-heading").hide();
    } else {
      changeStep("#step-2", "#step-3");
      $(".number-3").addClass("active");
      $(".number-2").removeClass("active");
      $("#replace-text1").text("What Colour Is " + horseName + "?");
    }
  });

  // Step 3 (formerly Step 4) to Step 2 (formerly Step 3)
  $("#step-3-back").on("click", function () {
    changeStep("#step-2", "#step-1");
    $(".number-1").addClass("active");
    $(".number-2").removeClass("active");
  });

  // Step 3 (formerly Step 4) to Step 4 (formerly Step 5)
  $("#mak_4-btn").on("click", function () {
    if ($("#step-4").hasClass("new-hidding")) {
      changeStep("#step-3", "#step-5");
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $("#step-4").hide();
    } else if ($("#step-2").hasClass("new-hidding")) {
      changeStep("#step-3", "#step-4");
      $(".mak_steps-heading").hide();
      $(".number-3").addClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $(".number-4").removeClass("active");
    } else {
      changeStep("#step-3", "#step-4");
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".mak_steps-heading").hide();
    }
  });

  // Step 4 (formerly Step 5) to Step 3 (formerly Step 4)
  $("#step-4-back").on("click", function () {
    if ($("#step-2").hasClass("new-hidding")) {
      changeStep("#step-3", "#step-1");
      $(".number-1").addClass("active");
      $(".number-4").removeClass("active");
      $(".number-3").removeClass("active");
      $(".number-2").removeClass("active");
      $("#step-2").hide();
    } else {
      changeStep("#step-3", "#step-2");
      $(".number-2").addClass("active");
      $(".number-3").removeClass("active");
      $("#replace-text").text("How big is " + horseName + "?");
    }
  });

  $("#mak_5-btn").on("click", function () {
    if ($("#step-2").hasClass("new-hidding")) {
      changeStep("#step-4", "#step-5");
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $(".mak_top-steps").show();
      $(".mak_steps-heading").show();
    } else if ($("#step-3").hasClass("new-hidding")) {
      changeStep("#step-4", "#step-5");
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $(".mak_top-steps").show();
      $(".mak_steps-heading").show();
    } else {
      changeStep("#step-4", "#step-5");
      $(".number-5").addClass("active");
      $(".number-4").removeClass("active");
      $(".mak_top-steps").hide();
      $(".mak_steps-heading").show();
    }
  });

  // Step 5 (formerly Step 6) to Step 4 (formerly Step 5)
  $("#step-5-back").on("click", function () {
    if ($("#step-4").hasClass("new-hidding")) {
      changeStep("#step-5", "#step-3");
      $(".number-3").addClass("active");
      $(".number-5").removeClass("active");
      $("#step-4").hide();
    } else if ($("#step-2").hasClass("new-hidding")) {
      changeStep("#step-4", "#step-3");
      $(".number-2").addClass("active");
      $(".number-4").removeClass("active");
      $(".number-1").removeClass("active");
      $(".number-3").removeClass("active");
      $(".mak_top-steps").show();
      $(".mak_steps-heading").show();
    } else if ($("#step-3").hasClass("new-hidding")) {
      changeStep("#step-4", "#step-2");
      $(".number-2").addClass("active");
      $(".number-4").removeClass("active");
      $(".number-3").removeClass("active");
      $(".number-1").removeClass("active");
      $(".mak_top-steps").show();
    } else {
      changeStep("#step-4", "#step-3");
      $(".number-3").addClass("active");
      $(".number-4").removeClass("active");
      $(".mak_top-steps").show();
    }

    // Reset step bar visibility
    $(".step-6-bar").hide();
    $(".mak_steps-heading").show();
    $(".mak_top-steps").show();
  });

  // Step 5 (formerly Step 6) to Step 6 (formerly Step 2)
  $("#mak_6-btn").on("click", function () {
    changeStep("#step-6", "#step-7");
    $(".number-6").addClass("active");
    $(".number-5").removeClass("active");
    $(".step-6-bar").hide();
  });

  // Step 6 (formerly Step 2) to Step 5 (formerly Step 6)
  $("#step-6-back").on("click", function () {
    if ($("#step-5").hasClass("new-hidding")) {
      changeStep("#step-6", "#step-4");
      $(".number-4").addClass("active");
      $(".number-6").removeClass("active");
      $("#step-5").hide();
    } else if ($("#step-2").hasClass("new-hidding")) {
      changeStep("#step-6", "#step-5");
      $(".mak_top-steps").show();
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $(".mak_steps-heading").hide();
      $(".step-6-bar").hide();
    } else if ($("#step-3").hasClass("new-hidding")) {
      changeStep("#step-6", "#step-5");
      $(".mak_top-steps").show();
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $(".mak_steps-heading").show();
      $(".step-6-bar").hide();
    } else if ($("#step-4").hasClass("new-hidding")) {
      changeStep("#step-6", "#step-5");
      $(".mak_top-steps").show();
      $(".number-4").addClass("active");
      $(".number-3").removeClass("active");
      $(".number-2").removeClass("active");
      $(".number-1").removeClass("active");
      $(".mak_steps-heading").show();
      $(".step-6-bar").hide();
    } else {
      changeStep("#step-6", "#step-5");
      $(".number-5").addClass("active");
      $(".number-6").removeClass("active");
      $(".mak_top-steps").hide();
      $(".mak_steps-heading").show();
      $(".step-6-bar").hide();
    }
  });

  // Step 6 (formerly Step 2) to Step 7
  $("#mak_two-btn").on("click", function () {
    var firstName = $('input[name="contact[first_name]"]').val().trim();
    var email = $('input[name="contact[email]"]').val().trim();
    var horseName = $('input[name="properties[Horses Name]"]').val().trim();
    var hourseColor = $('[name="colour"]:checked').val();
    var hourseSize = $('[name="size"]:checked').val();
    var checkbox = $("#i-agree-to-the-terms-of-use-privacy-policy").is(
      ":checked"
    );

    if (firstName === "" || email === "" || !checkbox) {
      alert("Please enter your name, email address, and agree to the terms.");
      return;
    }

    changeStep("#step-5", "#step-6");
    $(".mak_steps-heading").hide();
    $(".mak_top-steps").hide();
    $(".step-6-bar").show();
    klaviyo.identify({
      'email' : email,
      'first_name' : firstName,
      'House Name': horseName,
      'Hourse Size': hourseSize,
      'Hourse Color': hourseColor,
      'url': `/pages/essentials-subscription-box?name=${firstName}&email=${email}&hourse_name=${horseName}&hourse_size=${hourseSize}&hourse_color=${hourseColor}`,
      '$consent': ['email']
    });
    subscribeForm(email);
  });

  // Step 7 to Step 6 (formerly Step 2)
  $("#step-7-back").on("click", function () {
    changeStep("#step-7", "#step-6");
    $(".number-6").addClass("active");
    $(".step-6-bar").show();
  });

  // Proceed to checkout and add product to cart
  $("#mak-checkout").on("click", function () {
    var formData = {
      "Horses Name": $('input[name="properties[Horses Name]"]').val(),
      Name: $('input[name="contact[first_name]"]').val(),
      Email: $('input[name="contact[email]"]').val(),
    };

    // Collect data from visible steps
    if (!$("#step-2").hasClass("new-hidding")) {
      formData.Size = $('input[name="size"]:checked').val();
    }
    if (!$("#step-3").hasClass("new-hidding")) {
      formData.Colour = $('input[name="colour"]:checked').val();
    }
    if (!$("#step-4").hasClass("new-hidding")) {
      formData.Treats = $('input[name="treats"]:checked').val();
    }

    // Prepare tags for customer record
    var inputFieldTags = document.querySelector('input[name="contact[tags]"]');
    var initialTags = inputFieldTags ? inputFieldTags.value : "";
    var tagsValue = Object.values(formData)
      .filter(
        (value, index) =>
          value !== undefined && value !== "" && index !== 1 && index !== 2
      )
      .join(", ");
    tagsValue = initialTags + (initialTags ? ", " : "") + tagsValue;
    $('input[name="contact[tags]"]').val(tagsValue);

    // Add to cart and proceed
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: 1,
        id: $('input[name="susbscription"]:checked').val(),
        selling_plan: $('input[name="susbscription"]:checked').attr("data-sub"),
        properties: formData,
      },
      dataType: "json",
      success: function () {
        $("#mak-form-submit").trigger("click");
      },
      error: function (xhr, status, error) {
        console.error("Error adding product to cart:", error);
      },
    });
  });
});
$(document).ready(function () {
    // Helper to get URL parameter
    function getUrlParam(param) {
        let urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Get all parameters
    const name = getUrlParam('name');
    const email = getUrlParam('email');
    const hourseName = getUrlParam('hourse_name');
    const hourseSize = getUrlParam('hourse_size');
    const hourseColor = getUrlParam('hourse_color');
    const deal = getUrlParam('deal');

    // Step 1: Horse Name
    if (hourseName) {
        $('[name="properties[Horses Name]"]').val(hourseName);
        $('#mak_one-btn').click();
    } else {
        return; // Stop if missing
    }

    // Step 2: Horse Size
    if (hourseSize && $('[name="size"][value="' + hourseSize + '"]').length) {
        $('[name="size"][value="' + hourseSize + '"]').prop('checked', true);
        $('#mak_3-btn').click();
    } else {
        return;
    }

    // Step 3: Horse Color
    if (hourseColor && $('[name="colour"][value="' + hourseColor + '"]').length) {
        $('[name="colour"][value="' + hourseColor + '"]').prop('checked', true);
        $('#mak_4-btn').click();
    } else {
        return;
    }

    // Step 4: Contact Info
    if (name && email) {
        $('[name="contact[first_name]"]').val(name);
        $('[name="contact[email]"]').val(email);
        $('#i-agree-to-the-terms-of-use-privacy-policy').prop('checked', true);
        $('#mak_two-btn').click();
    } else {
        return;
    }

    // Step 5: Deal (Optional last)
    if (deal && $('[deal="' + deal + '"]').length) {
        $('[deal="' + deal + '"]').prop('checked', true);
        $('#mak_6-btn').click();
    }
});
